import { useParams } from 'react-router-dom';
import LocationAPI from '../../locations/LocationAPI';
import useWatchError from '../../../shared/hooks/useWatchError';
import { TEMPERATURE_UNIT_TYPES } from '..';
import StoreAPI from '../../store/StoreAPI';
import useTemperatureDefault from './useTemperatureDefault';
import { useAppSelector } from '../../../redux/store.model';
import useCurrentWorkspace from '../../../redux/workspace/hooks/useCurrentWorkspace';
import { getBusinessUnitFromStoreSelector } from '../../../redux/structure/selectors/Stores.selector';
import StructureAPI from '../../../redux/structure/StructureAPI';
import { fromBase64 } from '../../../shared/util/base64';

export function useTemperaturePreference() {
  // Manager by region
  const params = useParams();
  const { groupId, businessUnitId, storeId, marketId } = params;

  const entityId = storeId ?? groupId ?? businessUnitId ?? '';
  const { data: workspace } = useCurrentWorkspace(marketId);
  const structureWorkspaceId = marketId ?? workspace?.id;

  StructureAPI.useGetStructureV2Query(structureWorkspaceId, {
    skip: !structureWorkspaceId,
  });

  const businessUnit = useAppSelector((state) =>
    getBusinessUnitFromStoreSelector(state, {
      storeId: entityId,
      workspaceId: structureWorkspaceId,
    })
  );
  const businessUnitIdResponse = businessUnit?.id
    ? fromBase64(businessUnit.id)
    : '';

  const {
    error: errorTemperaturePreferenceByRegion,
    data: temperaturePreferenceByRegion,
  } = LocationAPI.useGetTemperaturePreferenceByGroupQuery(
    businessUnitIdResponse,
    {
      skip: !businessUnitIdResponse,
    }
  );

  useWatchError(errorTemperaturePreferenceByRegion);
  const temperatureDefault = useTemperatureDefault();

  // Operator by store
  const { data: storeInfoDetails } = StoreAPI.useGetStoreInfoDetailsQuery(
    undefined,
    {
      skip: !!entityId,
    }
  );
  const temperaturePreferenceStore = storeInfoDetails?.preferredUnit;
  // merge
  const temperaturePreference =
    temperaturePreferenceByRegion ??
    temperaturePreferenceStore ??
    temperatureDefault;

  // support DONT_CARE
  if (temperaturePreference === TEMPERATURE_UNIT_TYPES.DONT_CARE)
    return temperatureDefault;

  return temperaturePreference;
}
